<div class="flex-col flex">
    <div class="mat-subtitle-1 widget-name">{{ formattedLabel }}</div>
    <div class="widget-container flex-col">
        @for (item of data; track item; let i = $index) {
            <div class="widget-list-item flex-col">
                <div class="cb-padding-top cb-padding-bottom start-start flex-row flex">
                    <div class="flex-col flex">
                        <span class="mat-body-2">
                            {{ item.label }}
                            {{
                                item.secondaryLabel != undefined ? '- ' + item.secondaryLabel : ''
                            }}</span
                        >
                        @if (!!item.description) {
                            <span class="mat-caption"> {{ item.description }}</span>
                        }
                        @if (!!item.furtherDescription) {
                            <span class="mat-caption"> {{ item.furtherDescription }}</span>
                        }
                        @if (displayStatus && item.primaryEnumLabel) {
                            <span class="mat-caption"> {{ item.primaryEnumLabel }}</span>
                        }
                        @if (showDueDate) {
                            <span class="mat-caption"> Due: {{ item.dueDate | cbDate }}</span>
                        }
                    </div>
                    <button
                        mat-icon-button
                        class="cb-margin-right"
                        [disabled]="viewItemUrl(item)?.url === '#'"
                        (click)="goToItem(viewItemUrl(item), $event)"
                    >
                        <mat-icon>pageview</mat-icon>
                    </button>
                </div>
                @if (i < data.length - 1) {
                    <hr class="mat-divider" />
                }
            </div>
        }
        @if (!data || !data.length) {
            <span class="start-center flex layoutGap-6">
                <mat-icon class="mat-accent">info_circle</mat-icon>
                <div>There are no {{ formattedLabel.toLowerCase() }}</div>
            </span>
        }
    </div>
</div>
